import { Toast } from "../../../../components/Common/Toast";
import { CONFIG } from "../../../../config/mainConfig";
import { HTTPStatusEnum } from "../../../../interfaces/log.interface";
import { PlanDetailsModel } from "../../../../interfaces/plan.interface";
import { callAPI } from "../../../../services/api.service";

export const deletePlan = async (planId: string) => {
    try {
        const response = await callAPI(`admin/plan/delete`, { planId });
        if (response?.status === HTTPStatusEnum.OK) {
            Toast("Plan Deleted Successfully");
            return true;
        } else {
            Toast(response?.message || "Failed to delete plan", true);
            return false;
        }
    } catch (error) {
        Toast("Plan Delete Failed", true);
        throw error;
    }
};

export const getPlans = async (
    setPlans: (plan: any) => void, 
    userCurrentPlan: string | null = null, 
    userReq: boolean = false,
    userCountry?: string
) => {
    try {
        // Build query parameters for country-based pricing
        const queryParams = userCountry ? `?country=${userCountry}` : '';
        
        const response = await callAPI(`plans/getPlans${queryParams}`);
        if (response && response.plans) {
            let filteredPlans = userCurrentPlan
                ? response?.plans?.filter((plan: PlanDetailsModel) => plan?.name !== userCurrentPlan)
                : response.plans;

            if (userReq === true) filteredPlans = response?.plans?.filter(
                (plan: PlanDetailsModel) => plan?.name !== CONFIG.PROMO_PLAN && plan?.maintenanceMode === false
            );

            setPlans(filteredPlans);
        } else Toast("Failed to get plans", true);
    } catch (error) {
        Toast("Failed to get plans", true);
    }
};